import React, { useContext } from 'react'
import "./ReviewProd.css"
import { MdClose } from 'react-icons/md'
import { Context } from '../../../utils/context'

function ReviewProd() {
  const {cartItems, handleRemoveFromCart} = useContext(Context);
  
  return (
    <>
    {cartItems.map((item: any) => (
      <>
      <tr className='prod-info-row' key={item.id}>
        <td><MdClose onClick={() => handleRemoveFromCart(item)}/></td>
        <td className='review-img'><img src={item?.attributes?.img?.data[0]?.attributes?.url} alt="" /></td>
        <td>{item.attributes.categories?.data?.[0]?.attributes?.title}</td>
        <td>&#8377;{item.attributes.price}</td>
        <td>{item.attributes.quantity}</td>
        <td>&#8377;{item.attributes.price * item.attributes.quantity}</td>
      </tr>

      </>
    ))}
    {cartItems.map((item: any) => (
      <>
      <tbody className='res-prod-info' key={item.id}>
        <tr>
          <th><MdClose /></th>
        </tr>
        <tr>
          <th>Product:</th>
          <td className='review-img'><img src={item?.attributes?.img?.data[0]?.attributes?.url} /></td>
        </tr>
        <tr>
          <th>Category:</th>
          <td className='res-qty'>{item.attributes.categories?.data?.[0]?.attributes?.title}</td>
        </tr>
        <tr>
          <th>Price:</th>
          <td className='res-qty'>&#8377;{item.attributes.price}</td>
        </tr>
        <tr>
          <th>Quantity:</th>
          <td className='res-qty'>{item.attributes.quantity}</td>
        </tr>
        <tr>
          <th>Subtotal:</th>
          <td className='res-qty'>&#8377;{item.attributes.price * item.attributes.quantity}</td>
        </tr>
      </tbody>
      </>
    ))}
    </>
  )
}

export default ReviewProd
